import { Theme } from '@material-ui/core';
import { NONE, RATING_COLORS, TRating } from 'src/constants/lead/ratings';

/**
 * Returns the color of the rating based on the visible temperatures and the rating
 *
 * @param {string} rating - The rating to get the color for
 * @param {Theme} theme - The theme to use
 * @return {*}  {string}
 */
export const getRatingColor = (rating: TRating, theme: Theme): string => {
    if (rating === NONE) return theme.palette.text.primary;

    return RATING_COLORS[rating];
};
